import React, { useState, useRef } from "react";
import { ECLDialog, ECLThemeImage } from "../..";
import "./ECLBlockOptions.css";

// props
// block - The block data object
// instanceId - unique id for the containing block
// settingsWidget - if included, the settings widget to be displayed
// settingsWidgetCallback - function to be called when settings button is clicked
// settingsWidgetInit - initial state of settings widget (open/closed)
// settingsWidgetHeight - height of the settings widget when open
// expandWidget - if included, the expand button will display this widget in the modal

export default function ECLBlockOptions(props) {
   const [settingsWidgetOpen, setSettingsWidgetOpen] = useState(
      props.settingsWidgetInit || false,
   );
   const blockOptionsContainerRef = useRef(null);

   function toggleSettingsBox(e) {
      e.preventDefault();
      //Call settingsWidgetCallback, passing in the state of settings widget after toggle
      props.settingsWidgetCallback &&
         props.settingsWidgetCallback(!settingsWidgetOpen);
      setSettingsWidgetOpen(!settingsWidgetOpen);
   }

   let settingBoxHeight;
   if (settingsWidgetOpen) {
      if (blockOptionsContainerRef.current) {
         if (props.settingsWidget)
            blockOptionsContainerRef.current.lastChild.style.opacity = 1;
      }
      settingBoxHeight = 40 + props.settingsWidgetHeight + "px";
   } else {
      if (blockOptionsContainerRef.current) {
         if (props.settingsWidget)
            blockOptionsContainerRef.current.lastChild.style.opacity = 0;
      }
      settingBoxHeight = "40px";
   }

   return (
      <div
         ref={blockOptionsContainerRef}
         className="block-options-container"
         style={{ height: settingBoxHeight }}
      >
         <div className="block-options-bar">
            <label>{props.block.data.name}</label>
            <div className="block-options-bar-buttons">
               <ECLDialog
                  title={props.block.data.name}
                  dropDownModal={true}
                  triggerText={
                     <ECLThemeImage
                        fontAwesome="expand"
                        alt="Expand to full screen"
                     />
                  }
                  contentSectionClass={"expand-block-modal"}
                  customButtons={{}}
               >
                  <div
                     id={"block-modal" + props.instanceId}
                     className="block-modal-container"
                  >
                     {props.expandWidget}
                  </div>
               </ECLDialog>
               {props.settingsWidget && (
                  <button
                     className={
                        settingsWidgetOpen
                           ? "settings-button settings-open"
                           : "settings-button settings-closed"
                     }
                     onClick={(e) => {
                        toggleSettingsBox(e);
                     }}
                  >
                     <ECLThemeImage
                        fontAwesome="gear"
                        alt="Toggle block settings"
                     />
                  </button>
               )}
            </div>
         </div>
         {props.settingsWidget}
      </div>
   );
}
